import { FC } from 'react'

import { Navigate, useLocation } from 'react-router-dom'

interface PreReleaseRedirectProps {
  to: string
}

export const PreReleaseRedirect: FC<PreReleaseRedirectProps> = ({ to }) => {
  const { search } = useLocation()

  return <Navigate replace to={{ pathname: to, search }} />
}
